import { useMembershipData } from 'src/api/Membership'

export const useIsUnityPassActive = () => {
  const { membershipData, loading } = useMembershipData()
  if (!membershipData || loading || !membershipData.activation) return false
  return membershipData.activation.active === true
}
